import { Model, Question } from '@psyomics/surveyjs-core';

const navigateToLastAnsweredQuestion = (model: Model): void => {
  const questions = model.getAllQuestions(true);
  let lastAnswered: Question | undefined = undefined;
  for (const q of questions) {
    if (!q.hasInput) continue;
    if ((q.isRequired && !q.isAnswered) || !q.validate()) break;
    if (q.isAnswered) lastAnswered = q;
  }

  if (lastAnswered) {
    const page = model.getPageByQuestion(lastAnswered);

    const panel = model.getPanelByName(lastAnswered.parent.name);
    model.currentPageNo = 0;
    model.currentPageNo = 1;
    model.currentPage = page;
    const panelsInPage = page.getAllPanels(true);
    const indexFound = panelsInPage.findIndex((panelToCompare) => panelToCompare === panel);

    if (indexFound > -1) {
      for (let i = 0; i < indexFound; i++) {
        model.nextPage();
      }
    }

    focusWhenRendered(model, lastAnswered);
  }
};

function focusWhenRendered(model: Model, q: Question) {
  const handler = (sender: Model, opts: { question: Question }) => {
    if (opts.question === q) {
      q.focus();
      sender.onAfterRenderQuestion.remove(handler);
    }
  };
  model.onAfterRenderQuestion.add(handler);
}

export { navigateToLastAnsweredQuestion };
